export enum MailingStatus {
    pending = 1,
    inProgress,
    sent,
    canceled
}